import React from 'react';
import queryString from 'qs';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Link } from 'react-router-dom';
import { CLIENT_SIGNUP, INVESTOR_SIGNUP, FORGOT_PASSWORD } from 'app/constants/Routes';

import { renderField } from 'app/utils/ReduxFormUtils';
import validate from './Validate';
import Alert from '../Alert';
import Microsoft from 'app/assets/images/microsoft.png';

const LoginFormComponent = (props) => {
    const { handleSubmit, onSubmit, submitting, errorMsg, location, loginWithMicrosoft, microsoftAuthErr, authCancelled } = props;
    const qs = location && location.search && queryString.parse(location.search, { ignoreQueryPrefix: true });
    const { nexturl } = qs || {};

    const { from } = location.state || { from: { pathname: nexturl || '/' } };
    from.pathname = from.pathname === '/change-password' ? '/' : from.pathname;

    return (
        <div className="login">
            <h4>Log In to CredAvenue</h4>
            <form onSubmit={handleSubmit((data) => onSubmit({ ...data }, from))} autoComplete="off">
                <div className="form-group">
                    <Field
                        name="email"
                        type="text"
                        className="form-control"
                        containerClassName="frm-grp"
                        component={renderField}
                        label="Enter your Email"
                    />
                    <i>@</i>
                </div>
                <div className="form-group">
                    <Field
                        name="password"
                        type="password"
                        className="form-control"
                        containerClassName="frm-grp"
                        component={renderField}
                        label="Enter your Password"
                    />
                    <i className="icon-lock-fill" />
                </div>
                {errorMsg && (
                    <p className="text-center">
                        <Alert type="danger" title={authCancelled ? errorMsg : 'Login Failed!'} msg={!authCancelled && errorMsg} isHTML />
                    </p>
                )}
                <ul className="actions">
                    <li>
                        <Link to={FORGOT_PASSWORD}>Forgot Password ?</Link>
                        <span>|</span>
                        <Link to={`${FORGOT_PASSWORD}?set_password=true`}>Password not setup ?</Link>
                    </li>
                    <li>
                        <button className="btn blu-nw pull-right violet-nw" disabled={submitting} type="submit">
                            {submitting ? 'Signing in' : 'Sign In'}
                        </button>
                    </li>
                </ul>
                <ul className="options">
                    <li className="line">
                        <span>Or</span>
                    </li>
                    {microsoftAuthErr && (
                        <li className="text-center error">
                            <Alert type="danger" title="Login Failed!" msg={microsoftAuthErr} isHTML />
                        </li>
                    )}
                    <li>
                        <button type="button" onClick={() => loginWithMicrosoft(from)}>
                            <img src={Microsoft} alt="microsoft-logo" /> Sign in with Microsoft
                        </button>
                    </li>
                    <li>
                        <p className="new-user">
                            New User? <a href={CLIENT_SIGNUP}>Signup as a Issuer</a>
                            <a href={INVESTOR_SIGNUP}>Signup as an Investor</a>
                        </p>
                    </li>
                </ul>
            </form>
        </div>
    );
};

const LoginForm = reduxForm({
    form: 'login',
    validate,
})(LoginFormComponent);
const selector = formValueSelector('login');
const mapStateToProps = (state) => ({
    formValues: selector(state, 'email', 'password'),
});

const reduxConnector = connect(mapStateToProps);

export default reduxConnector(LoginForm);
